import { takeEvery, put } from 'redux-saga/effects';
import companyRestaurantsActions from '../actionTypes/companyRestaurantsActions';
import { API_CALL } from '../actionTypes/sharedActions';
import {
  GET_COMPANY_RESTAURANTS_MAPPINGS,
  UPDATE_COMPANY_RESTAURANTS_MAPPING,
} from '../routes';

function* getCompanyRestaurantsMapping({ payload }) {
  const { data: { company_id } } = payload;

  yield put({
    type: API_CALL,
    payload: {
      url: GET_COMPANY_RESTAURANTS_MAPPINGS.replace(':id', company_id),
      method: 'GET',
      data: payload,
    },
    successAction: companyRestaurantsActions.getCompanyRestaurantsMappingSuccess,
    failureAction: companyRestaurantsActions.getCompanyRestaurantsMappingFailed,
  });
}

function* updateCompanyRestaurantsMapping({ payload }) {
  const { data: { company_id } } = payload;

  yield put({
    type: API_CALL,
    payload: {
      url: UPDATE_COMPANY_RESTAURANTS_MAPPING.replace(
        ':id',
        company_id,
      ),
      method: 'POST',
      data: payload,
    },
    successAction: companyRestaurantsActions.updateCompanyRestaurantsMappingSuccess,
    failureAction: companyRestaurantsActions.updateCompanyRestaurantsMappingFailed,
  });
}

export default function* watchCompanyRestaurantsMapping() {
  yield takeEvery(
    companyRestaurantsActions.getCompanyRestaurantsMapping,
    getCompanyRestaurantsMapping,
  );
  yield takeEvery(
    companyRestaurantsActions.updateCompanyRestaurantsMapping,
    updateCompanyRestaurantsMapping,
  );
}
